(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["device-finder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest('.shamos-device-finder__group[open]');
    if (!group) return;
    group.open = false;
    group.querySelector('summary').focus();
    event.stopPropagation();
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.shamos-device-finder__group[open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-with-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('focusin', event => {
    const row = event.target.closest('.shamos-benefit-row');
    const card = event.target.closest('.text-icon-column__item');
    if (!row || !card || row.scrollWidth <= row.clientWidth) return;
    requestAnimationFrame(() => {
      if (!card.contains(document.activeElement)) return;
      const viewport = row.getBoundingClientRect();
      const box = card.getBoundingClientRect();
      const left = box.left < viewport.left ? box.left - viewport.left : box.right > viewport.right ? box.right - viewport.right : 0;
      if (left) row.scrollBy({ left, behavior: 'auto' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
